import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "What does this acronym stand for?", -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  props: {
    numAcronym: {},
    totalAcronyms: {},
    curAcronym: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("h2", null, "Acronym " + _toDisplayString(props.numAcronym) + "/" + _toDisplayString(props.totalAcronyms), 1),
    _createElementVNode("dfn", null, _toDisplayString(props.curAcronym), 1),
    _hoisted_1
  ]))
}
}

})